export let TitleWidth = 150
export let InputWidth = 250

export let Height = 34
export let Top = 10